<template>
  <!-- Oculta a linha inteira quando o campo não está preenchido (em vez de "Indisponível") -->
  <div v-if="value" class="contact-info--row">
    <span class="info-chip">
      <emoji-or-icon :icon="icon" :emoji="emoji" icon-size="14" />
    </span>
    <div class="info-text">
      <span v-if="label" class="info-label">{{ label }}</span>
      <a
        v-if="href"
        :href="href"
        class="info-value text-truncate"
        :title="value"
      >
        {{ value }}
      </a>
      <span v-else class="info-value text-truncate" :title="value">
        {{ value }}
      </span>
    </div>
    <woot-button
      v-if="showCopy"
      type="submit"
      variant="clear"
      size="tiny"
      color-scheme="secondary"
      icon="clipboard"
      class-names="info-copy"
      @click="onCopy"
    />
  </div>
</template>
<script>
import alertMixin from 'shared/mixins/alertMixin';
import EmojiOrIcon from 'shared/components/EmojiOrIcon';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

export default {
  components: {
    EmojiOrIcon,
  },
  mixins: [alertMixin],
  props: {
    href: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      required: true,
    },
    emoji: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    showCopy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async onCopy(e) {
      e.preventDefault();
      await copyTextToClipboard(this.value);
      this.showAlert(this.$t('CONTACT_PANEL.COPY_SUCCESSFUL'));
    },
  },
};
</script>
<style scoped lang="scss">
// Linha do campo do contato: chip de ícone + rótulo/valor + copiar
.contact-info--row {
  display: flex;
  align-items: center;
  gap: var(--space-small);
  padding: var(--space-small) 0;

  & + .contact-info--row {
    border-top: 1px solid var(--s-50);
  }
}

.info-chip {
  flex: none;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 8px;
  background: #e1f8fb;
  display: grid;
  place-items: center;
  color: #0a7581;

  ::v-deep .icon,
  ::v-deep .icon--font,
  ::v-deep .emoji {
    color: #0a7581;
    display: inline-flex;
    width: auto;
  }
}

.info-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  line-height: 1.3;
}

.info-label {
  font-size: var(--font-size-micro);
  color: var(--s-400);
  letter-spacing: 0.2px;
}

.info-value {
  font-size: var(--font-size-small);
  color: #002136;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:is(a):hover {
    text-decoration: underline;
  }
}

::v-deep .info-copy {
  flex: none;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}

.contact-info--row:hover ::v-deep .info-copy {
  opacity: 1;
}
</style>
